export default function SeoJsonLd({ data }: { data: Record<string, unknown> }) {
  const jsonString = JSON.stringify(data, null, 0);
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: jsonString }}
    />
  );
}